import { SessionState } from '../Enums';
import MessageService from '../MessageService';
import CookieConsentScreen from '../Screens/CookieConsentScreen';
import SessionService from '../SessionService';
import { UiService } from '../UiService';
import CookieService from './CookieService';

export default class CookieConsentManager {
    /**
     * CookieConsentManager constructor
     * @param {SessionService} sessionService
     * @param {CookieService} cookieService
     * @param {MessageService} messageService
     * @param {UiService} uiService
     * @param {object} jsModuleSettings
     */
    constructor(sessionService, cookieService, messageService, uiService, jsModuleSettings) {
        this.sessionService = sessionService;
        this.cookieService = cookieService;
        this.messageService = messageService
        this.uiService = uiService;
        this.jsModuleSettings = jsModuleSettings;
    }

    async getCookieConsent() {
        if (jsModuleSettings && jsModuleSettings.skippedPages && jsModuleSettings.skippedPages.includes("consent")) {
            await this.sessionService.logMessage('info', `Cookie consent was given. Consent text was: Handled by external`);
            return true;
        }

        const wasConsentAlreadyGiven = await this.wasConsentAlreadyGiven();
        if (wasConsentAlreadyGiven) {
            return true;
        }

        const cookieConsentScreen = new CookieConsentScreen(this.messageService, this.uiService);
        const cookieConsentResult = await cookieConsentScreen.getCookieConsent();
        if (cookieConsentResult) {
            await this.cookieConsentProvided(true, document.getElementById('wrapper-base-screen').innerText);
        } else {
            await this.cookieConsentProvided(false);
        }

        return cookieConsentResult;
    }

    /**
     * Depending on the provided result resolve or reject the promise
     * @param {boolean} result whether the consent was given or not
     * @param {string} consentText the text of the consent (optional, only used if consent given)
     * @returns {void}
     */
    async cookieConsentProvided(result, consentText) {
        if (!!result === true) {
            console.log("logging cookie consent");
            consentText = consentText.replace(/\n/g, '\\n').replace(/\s+/g, ' ').substr(0, 1024);
            await this.sessionService.logMessage('info', `Cookie consent was given. Consent text was: ${consentText}`);
            this.cookieService.setCookie("CookieConsentGiven", JSON.stringify({ Date: new Date(), Text: consentText }), 30);
        }
    }

    async resetConsent() {
        this.cookieService.deleteCookie("CookieConsentGiven");
        console.log("cookie consent was reset");
        await this.sessionService.changeState(SessionState.declined, null, 'GDPR cookie consent reset');
        await this.sessionService.logMessage('info', "Cookie consent was reset");
    }

    /**
     * Checks whether the consent was already given or not
     * only checks the first time after returns always the first time result
     * @param {string} consentText The text of the consent
     * @returns {boolean}
     */
    async wasConsentAlreadyGiven() {
        if (!this.storedCookieConsent) {
            this.storedCookieConsent = this.cookieService.getCookie("CookieConsentGiven");
            if (this.storedCookieConsent) {
                console.log('logging stored cookie consent');
                await this.sessionService.logMessage('info', `Stored cookie conesent found. Info: ${this.storedCookieConsent}`);
            }
        }
        //todo: should check the consent text?
        return !!this.storedCookieConsent;
    }

    async reviewCookieConsent () {
        await this.resetConsent();
        window.location.reload();
    };

    showCookieConsentReviewBar(identityKey) {
        const cookieConsentBar = document.querySelector('section#cookieConsentReview');
        cookieConsentBar.innerHTML = cookieConsentBar.innerHTML.replace('###ParticipantID###', identityKey);
        cookieConsentBar.style.display = '';
        //cookieConsentBar.querySelector('#GdprSettingsReset').addEventListener('click', async () => await this.reviewCookieConsent());
    } 
}
